<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6TQc0S/tc-custom/9781616898380.jpg?1703877191449" alt="This image is the cover for the book Gardener Says"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gardener Says
      </h1>
      <p class="bookDescription body article font2">
        <b>A “breezy collection” of quotes about gardening, “filled with humor, reflection, and a love of plants and planting” (<i>Publishers Weekly</i>).</b><br/>  <br/><i>The Gardener Says</i> invites you to a festive garden party where guests ranging from Gertrude Jekyll and Henry David Thoreau to Michelle Obama and Michael Pollan share their insights and words of inspiration on the topic of gardening.<br/>  <br/> Ranging from the humorous to the poignant, these quotes from gardeners, poets, philosophers, and landscape designers highlight both the joys and challenges of gardening—the exhaustion at the end of a long day’s work, the satisfaction of seeing a flower blossom, the peace and happiness of time spent in quiet contemplation.<br/>  <br/> A delightful hobby, a potent tool for ecological and social transformation, and a crucial reminder of our place in nature, gardening is, in the words of Mirabel Osler, the one occupation where “if you were to creep up behind someone at their work, you would find them smiling.”<br/>  <br/> “Will inspire you . . . [This] compilation of thoughtful and powerful insights helped me understand, on a personal level, my desire to garden.” —<i>The Oregonian</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nina Pick
      </h2>
      
      <p class="authorDescription body article">Nina Pick is a writer and editor who divides her time between New York and Connecticut. She has served as an editor at Princeton Architectural Press, the New Farmer's Almanac, and the Inverness Almanac. She has been an enthusiastic quote collector since the age of four.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Princeton Architectural Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33219da5